import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./required-documents.css";
import { 
  FaIdCardAlt, 
  FaCreditCard, 
  FaUniversity, 
  FaReceipt, 
  FaFileAlt 
} from "react-icons/fa";

const documentCategories = [
  {
    id: "identity",
    icon: <FaIdCardAlt />,
    title: "1. Identity & Address Proof",
    color: "#00ff7f", // Neon Green
    items: [
      "Aadhaar Card (Front & Back)", 
      "PAN Card (Mandatory)", 
      "Passport / Voter ID (Optional)",
      "Utility Bill (Electricity/Gas) - for address verification"
    ],
  },
  {
    id: "income",
    icon: <FaReceipt />,
    title: "2. Income & Employment",
    color: "#d50ac6", // Magenta
    items: [
      "Last 3 Months Salary Slips (Salaried)", 
      "Latest Form 16 / ITR Copy (Salaried)", 
      "Last 6 Months Bank Statement",
      "Business Proof (Shop Act/GST Registration) (Self-Employed)"
    ],
  },
  {
    id: "bank",
    icon: <FaUniversity />,
    title: "3. Bank Details & Others",
    color: "#ecd969", // Gold/Yellowish
    items: [
      "Cancelled Cheque (for bank verification)",
      "Recent Photograph (Passport size)",
      "Digital Signature (E-Sign)",
    ],
  },
];

const RequiredDocuments = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeCategory = documentCategories[activeIndex];

  return (
    <section className="rd-wrap">
      {/* Background Glows (Subtle, fixed elements) */}
      <div className="rd-bg-glow" style={{ '--glow-color': activeCategory.color }}></div>
      
      <div className="rd-container">
        <div className="rd-header-content">
            <div className="rd-eyebrow">Digital Submission</div>
            <h2 className="rd-title">
            Your <span className="rd-highlight">Simple Document </span> Checklist
            </h2>
            <p className="rd-sub">
            To ensure instant approval, please have the following documents ready for secure digital upload.
            </p>
        </div>

        <div className="rd-content-area">
          {/* LEFT SIDE: Category Navigation (Tabbed List) */}
          <div className="rd-tabs-nav">
            {documentCategories.map((category, index) => (
              <div
                key={category.id}
                className={`rd-tab-item ${activeIndex === index ? 'active' : ''}`}
                onClick={() => setActiveIndex(index)}
              >
                <div className="rd-tab-icon" style={{ color: category.color }}>
                    {category.icon}
                </div>
                <span className="rd-tab-title">{category.title}</span>
                {/* Neon highlight line */}
                <div className="rd-tab-line" style={{ background: category.color }}></div>
              </div>
            ))}
          </div>

          {/* RIGHT SIDE: Document List (Detail View) */}
          <div className="rd-detail-view" key={activeCategory.id}>
            <div 
                className="rd-detail-header"
                style={{ '--header-color': activeCategory.color }}
            >
                {activeCategory.icon}
                <h3>{activeCategory.title}</h3>
            </div>
            
            <ul className="rd-document-list">
              {activeCategory.items.map((item, i) => (
                <li key={i}>
                    <FaFileAlt className="list-icon" />
                    <span className="list-text">{item}</span>
                    <span className="list-tag">PDF/JPEG</span>
                </li>
              ))}
            </ul>
            
            <div className="rd-detail-footer">
                <p>All documents must be clear, legible, and current.</p>
                <Link to="/apply-now">
                    <button className="rd-btn-primary">Proceed to Secure Upload</button>
                </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RequiredDocuments;